export const PAYMENT_TYPE_UPFRONT = 'upfront';
export const PAYMENT_TYPE_UPON_COMPLETION = 'upon_completion';
export const PAYMENT_TYPE_SENTENCE_PREDICATE = {
    [PAYMENT_TYPE_UPFRONT]: 'upfront.',
    [PAYMENT_TYPE_UPON_COMPLETION]: 'at the end of our engagement.'
};
export const PAYMENT_TYPE_LABEL = {
    [PAYMENT_TYPE_UPFRONT]: 'Up front',
    [PAYMENT_TYPE_UPON_COMPLETION]: 'Upon completion'
};
export const CONTRACT_PAYMENTS_MODE_INDIVIDUAL = 'individual';
export const CONTRACT_PAYMENTS_MODE_PER_TASK = 'per_task';
export const CONTRACT_PAYMENTS_MODE_PROPOSED = 'proposed';
export const COMMISSION_PAYMENTS = 'has_commission_payments';
export const CONTRACT_PAYMENTS = 'has_contract_payments';
export const PAYMENT_TYPE_LABELS = {
    [COMMISSION_PAYMENTS]: 'Commission',
    [CONTRACT_PAYMENTS]: {
        [CONTRACT_PAYMENTS_MODE_INDIVIDUAL]: 'Fixed Payment',
        [CONTRACT_PAYMENTS_MODE_PER_TASK]: 'Per Task',
        [CONTRACT_PAYMENTS_MODE_PROPOSED]: 'Proposed'
    }
};
